import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CatalogoEffects } from "@store/catalogo/catalogo.effect";
import { CatalogoReducer } from "@store/catalogo/catalogo.reducer";
import { userReducer } from "@store/user/user.reducer";
import { brandsReducer } from "@store/brands/brands.reducer";


export const ModulesStore = [
    StoreModule.forRoot({
        user: userReducer,
        catalogo: CatalogoReducer,
        brands: brandsReducer
    }, {}),
    EffectsModule.forRoot([
        CatalogoEffects
    ])
]